console.log("✅ Oceanslure desktop arrows patch v4 loaded");

(() => {
  const DESKTOP = () => window.matchMedia("(min-width: 990px)").matches;

  function getGalleryFromButton(btn) {
    // Find the nearest media-gallery for THIS product section
    const scope =
      btn.closest('section[id^="shopify-section-"]') ||
      btn.closest('[id^="MainProduct-"]') ||
      btn.closest("product-info") ||
      document;

    return (
      scope.querySelector("media-gallery[id^='MediaGallery-']") ||
      scope.querySelector("[id^='MediaGallery-']") ||
      document.querySelector("media-gallery[id^='MediaGallery-']") ||
      document.querySelector("[id^='MediaGallery-']")
    );
  }

  function getTrack(gallery) {
    // Dawn: track is usually ul.slider or ul.product__media-list
    return (
      gallery.querySelector("ul.slider") ||
      gallery.querySelector(".slider") ||
      gallery.querySelector("ul.product__media-list") ||
      gallery.querySelector(".product__media-list") ||
      null
    );
  }

  function getSlides(track) {
    // Only main slides (not thumbnails)
    const slides = Array.from(
      track.querySelectorAll("li.product__media-item, li.slider__slide")
    );

    // Filter out thumbnail items if any ever appear
    return slides.filter((li) => li.classList.contains("product__media-item") || li.classList.contains("slider__slide"));
  }

  function getCurrentIndex(slides) {
    // Dawn marks active in a few ways; try all
    let i = slides.findIndex((li) => li.classList.contains("is-active"));
    if (i !== -1) return i;

    i = slides.findIndex((li) => li.getAttribute("aria-hidden") === "false");
    if (i !== -1) return i;

    i = slides.findIndex((li) => li.getAttribute("aria-current") === "true");
    if (i !== -1) return i;

    // Fallback: approximate by most centered
    const track = slides[0]?.closest("ul, .slider, .product__media-list");
    if (!track) return 0;
    const tr = track.getBoundingClientRect();
    const cx = tr.left + tr.width / 2;

    let best = 0;
    let bestDist = Infinity;
    slides.forEach((li, idx) => {
      const r = li.getBoundingClientRect();
      const licx = r.left + r.width / 2;
      const d = Math.abs(licx - cx);
      if (d < bestDist) {
        bestDist = d;
        best = idx;
      }
    });
    return best;
  }

  function goToIndex(track, slides, idx) {
    const safe = Math.max(0, Math.min(slides.length - 1, idx));
    const target = slides[safe];
    if (!target) return;

    target.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });

    // Nudge: some Dawn builds update state on scroll
    requestAnimationFrame(() => {
      track.dispatchEvent(new Event("scroll", { bubbles: true }));
    });
  }

  function handleArrowClick(e) {
    if (!DESKTOP()) return;

    const btn = e.target.closest("button.slider-button");
    if (!btn) return;

    const isPrev = btn.classList.contains("slider-button--prev") || btn.name === "previous";
    const isNext = btn.classList.contains("slider-button--next") || btn.name === "next";
    if (!isPrev && !isNext) return;

    const gallery = getGalleryFromButton(btn);
    if (!gallery) return;

    const track = getTrack(gallery);
    if (!track) return;

    const slides = getSlides(track);
    if (slides.length < 2) return;

    // We take over the movement, but we do NOT touch the counter markup.
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    const cur = getCurrentIndex(slides);
    goToIndex(track, slides, cur + (isPrev ? -1 : 1));
  }

  // capture phase so we run even if other scripts interfere
  document.addEventListener("click", handleArrowClick, true);
})();